module.exports = "https://web-assets.ifttt.com/packs/media/home/discover-1786da2d.png";